import { ref } from '@vue/composition-api'
import store from '@/store/'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'



export default function useReportDownloadModal() {

    const toast = useToast()

    const dataLoading = ref(false)
    const downloadReportModalFormData = ref({})


    const requestDataConstructor = (reportObject) => {
        return reportObject
    }


    const downloadData = (downloadDataUrl, reportObject, downloadReportModalFormData, requestDataConstructor=requestDataConstructor, callback) => {

        reportObject = JSON.parse(JSON.stringify(reportObject))
        downloadReportModalFormData = JSON.parse(JSON.stringify(downloadReportModalFormData))

        const data = requestDataConstructor(reportObject, downloadReportModalFormData);

        dataLoading.value = true
        store.dispatch(downloadDataUrl, { id: reportObject['id'], data: data })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));

                const link = document.createElement('a');
                link.href = downloadUrl

                link.setAttribute('download', 'file');

                if (response.headers['content-type'] === 'text/csv') {
                    link.setAttribute('download', 'file.csv');
                }

                if (response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    link.setAttribute('download', 'file.xlsx');
                }

                if (response.headers['content-type'] === 'application/pdf') {
                    link.setAttribute('download', 'file.pdf');
                }

                document.body.appendChild(link);
                link.click();
                link.remove();

                toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                        title: `Отчет выгружен`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `Отчет успешно выгружен`,
                    },
                });

                callback()

            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Ошибка выгрузки',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        text: "Не удалось выгрузить отчет, попробуйте позже или свяжитесь с администратором",
                    },
                })
        })
            .finally(()=>{
                dataLoading.value = false
            })

    }

    // const fetchFilterOptions = (ctx, callback) => {
    //     store.dispatch('search/search', {model_name: ctx.model_name})
    //         .then((response)=>{
    //             callback(response.data.results)
    //         })
    //         .catch((error)=>{
    //             console.log(error)
    //         })
    //
    // }

    return {
        dataLoading,
        downloadReportModalFormData,
        downloadData
        // fetchFilterOptions,
    }
}
